// extracted by mini-css-extract-plugin
export default {"container":"order-items_container__u2O1X","btn_back":"order-items_btn_back__9b4N2","list":"order-items_list__cd3b8","pagination":"order-items_pagination__cDDs1"};